import React, { InputHTMLAttributes } from 'react'

import clsxm from '@/utils/clsxm'

import IcDismiss from '~/assets/icons/icon-dismiss.svg'
import IcSearch from '~/assets/icons/icon-search.svg'

interface SearchBarProps extends InputHTMLAttributes<HTMLInputElement> {
  iconClassName?: string
  iconOnClick: (e: React.ChangeEvent<HTMLInputElement> | string) => void
}

const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>(({ iconClassName, iconOnClick, ...rest }, ref) => {
  return (
    <div className='relative z-10 w-full rounded-lg'>
      <input
        ref={ref}
        {...rest}
        placeholder={rest.placeholder}
        className={clsxm(
          'w-full rounded-lg border-neutral-border bg-white py-2 pl-3 pr-12 lg:px-3 lg:py-2.5',
          'flex-1 text-dark',
          'placeholder:text-sm placeholder:font-medium placeholder:text-neutral-placeholder focus:outline-0 focus:ring-0',
          rest.className
        )}
      />

      <div
        className={clsxm(
          'absolute inset-y-0 right-0 flex items-center justify-center pr-3 lg:pr-3',
          rest.value ? 'cursor-pointer' : 'pointer-events-none'
        )}
        onClick={() => iconOnClick('')}
      >
        {rest.value ? (
          <IcDismiss className={clsxm('block h-6 w-6', iconClassName)} />
        ) : (
          <IcSearch className={clsxm('block h-6 w-6', iconClassName)} />
        )}
      </div>
    </div>
  )
})

export default SearchBar
